<template>
  <div>
    <div class="line-charts">
      <div class="panel" :key="index" v-for="(name, index) in canShowChart">
        <h2>{{ $t(`DASHBOARD_ACTIVITY_CHARTS_${name}`) }}
          <div class="settings">
            <div class="period-btns" v-click-outside="() => closePeriod(name)">
              <span class="cm-select-label" :class="{ active: openPeriod === name }" @click="togglePeriod(name)">
                {{ $t(periodLabel) }}
                <span class="expand"></span>
              </span>
              <ul v-show="openPeriod === name">
                <li :class="{ active: activePeriod === 'daily' }" @click="setPeriod('daily')">{{ $t('DASH_DAILY') }}</li>
                <li :class="{ active: activePeriod === 'weekly' }" @click="setPeriod('weekly')">{{ $t('DASH_WEEKLY') }}</li>
                <li :class="{ active: activePeriod === 'monthly' }" @click="setPeriod('monthly')">{{ $t('DASH_MONTHLY') }}</li>
              </ul>
            </div>
          </div>
        </h2>
        <div class="m-chart">
          <div
            class="chart"
            :ref="`activity${name}`"
            style="width: 100%; height: 100%"
          ></div>
          <span class="chart-export"><i class="bi-download"></i>
            <ul class="export-list">
              <li @click="exportLineChart(name, 'svg')">SVG</li>
              <li @click="exportLineChart(name, 'csv')">CSV</li>
            </ul>
          </span>
        </div>
      </div>

      <div class="panel">
        <h2>{{ $t('DASH_GRW') }}
          <div class="settings">
            <div class="period-btns" v-click-outside="() => closePeriod('growth')">
              <span class="cm-select-label" :class="{ active: openPeriod === 'growth' }" @click="togglePeriod('growth')">
                {{ $t(periodLabel) }}
                <span class="expand"></span>
              </span>
              <ul v-show="openPeriod === 'growth'">
                <li :class="{ active: activePeriod === 'daily' }" @click="setPeriod('daily')">{{ $t('DASH_DAILY') }}</li>
                <li :class="{ active: activePeriod === 'weekly' }" @click="setPeriod('weekly')">{{ $t('DASH_WEEKLY') }}</li>
                <li :class="{ active: activePeriod === 'monthly' }" @click="setPeriod('monthly')">{{ $t('DASH_MONTHLY') }}</li>
              </ul>
            </div>
          </div>
        </h2>
        <div class="m-chart">
          <div
            class="chart"
            :ref="`activitygrowth`"
            style="width: 100%; height: 100%"
          ></div>
          <span class="chart-export"><i class="bi-download"></i>
            <ul class="export-list">
              <li @click="exportGrowthChart('svg')">SVG</li>
              <li @click="exportGrowthChart('csv')">CSV</li>
            </ul>
          </span>
        </div>
      </div>
      <div
        class="panel"
        :key="page.hash_id"
        v-for="(page, index) in getAnalizedAdminPages"
      >
        <div class="aud-header">
          <h2>{{ $t('DASHBOARD_ACTIVITY_CHARTS_subunsub') }}
            
          </h2>
          <div class="settings">
              <div class="period-btns" v-click-outside="() => closePeriod('sub' + index)">
                <span class="cm-select-label" :class="{ active: openPeriod === 'sub' + index }" @click="togglePeriod('sub' + index)">
                  {{ $t(periodLabel) }}
                  <span class="expand"></span>
                </span>
                <ul v-show="openPeriod === 'sub' + index">
                  <li :class="{ active: activePeriod === 'daily' }" @click="setPeriod('daily')">{{ $t('DASH_DAILY') }}</li>
                  <li :class="{ active: activePeriod === 'weekly' }" @click="setPeriod('weekly')">{{ $t('DASH_WEEKLY') }}</li>
                  <li :class="{ active: activePeriod === 'monthly' }" @click="setPeriod('monthly')">{{ $t('DASH_MONTHLY') }}</li>
                </ul>
              </div>
            </div>
          <div :class="`soc-sea ${page.colorName}`">
            <span :class="`soc-ico soc-${page.social.toLowerCase()}`"></span>
            {{ page.owner_name_medium }}
          </div>
        </div>
        <div class="m-chart">
          <div
            class="chart"
            :ref="`activitysubunsub${index}`"></div>
          <span class="chart-export"><i class="bi-download"></i>
            <ul class="export-list">
              <li @click="exportSubUnsubChart(index, 'svg')">SVG</li>
              <li @click="exportSubUnsubChart(index, 'csv')">CSV</li>
            </ul>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions, mapState } from "vuex";
import PageCharts from "@/models/page-charts";
import linesChart, { exportChart as exportLinesChart } from "@/models/charts/elines";
import Columns, { exportChart as exportColumnsChart } from "@/models/charts/ecolumns";
import ColumnsOne, { exportChart as exportColumnsOneChart } from "@/models/charts/ecolumns-one";
import moment from 'moment';
import ClickOutside from "vue-click-outside";
import { scheduleCharts } from "@/models/charts/echarts-touch";

export default {
  name: "Dash-activity-body",
  directives: { ClickOutside },
  computed: {
    ...mapGetters([
      "getSelectedPages",
      "loadingStatus",
      "getAnalizedPages",
      "getUnionPagesData",
      "getSocialOfPageInAnalize",
      "getAnalizedAdminPages",
    ]),
    locale() {
      return this.$locale.DASHBOARD.ACTIVITY_CHARTS;
    },
    periodLabel() {
      return { daily: "DASH_DAILY", weekly: "DASH_WEEKLY", monthly: "DASH_MONTHLY" }[this.activePeriod];
    },
    canShowChart() {
      const charts = [
        "likes",
        "comments",
        "reposts",
        "views",
        "posts",
        "stories",
        "interactions",
      ];
      const socials = this.getSocialOfPageInAnalize;
      const isAdmins = !!this.getAnalizedAdminPages.length;
      return charts.filter((name) => {
        if (name == "reposts") {
          if (socials.VK || socials.FB) return true;
          else return false;
        } else if (name == "stories") {
          const hasStories = this.getAnalizedAdminPages.some(
            (page) => page.stories.length
          );
          if ((socials.VK || socials.IG) && isAdmins && hasStories) return true;
          else return false;
        } else if (name == "interactions") {
          if (isAdmins) return true;
          else return false;
        } else if (name == "views") {
          if (socials.VK || socials.IG) return true;
          else return false;
        } else return true;
      });
    },
  },

  components: {},
  data() {
    return {
      chartNames: [],
      loaded: false,
      activePeriod: 'daily',
      openPeriod: null,
    };
  },
  methods: {
    // Helper method to determine the appropriate aggregation type for each metric
    getAggregationType(metric) {
      // Most activity metrics should be summed when in weekly/monthly view
      const sumMetrics = [
        "likes", "comments", "reposts", "views", "posts", 
        "stories", "interactions"
      ];
      
      if (sumMetrics.includes(metric)) {
        return "sum";
      }
      
      // Subscribers and other metrics that should show the latest value
      return "last";
    },
    
    disposeChart(chart) {
      const target = chart && typeof chart.dispose === "function" ? chart : chart && chart.chart;
      if (target && typeof target.dispose === "function") target.dispose();
    },

    // Helper to safely get DOM element
    getRefElement(refName) {
      if (this.$refs[refName]) {
        if (Array.isArray(this.$refs[refName])) {
          if (this.$refs[refName].length > 0) {
            return this.$refs[refName][0];
          }
        } else {
          return this.$refs[refName];
        }
      }
      return null;
    },
    
    // On-screen charts first, three at a time. The rest wait until scrolled into view.
    renderCharts() {
      const renderId = (this._renderId = (this._renderId || 0) + 1);
      if (this._stopCharts) this._stopCharts();
      if (this.charts.length) {
        this.charts.forEach((chart) => this.disposeChart(chart));
        this.charts = [];
      }

      const { pages, datesRangePosts, datesRangeStories } = this.getUnionPagesData;
      const colors = Object.entries(this.$colors).map(([key, value]) => {
        return { key, value };
      });
      const jobs = [];

      this.canShowChart.forEach((name, index) => {
        const chartElement = this.getRefElement(`activity${name}`);
        if (!chartElement) return;
        jobs.push({
          el: chartElement,
          run: async () => {
            const chart = await linesChart({
              pages,
              datesRangePosts,
              datesRangeStories,
              name,
              ref: chartElement,
              color: colors[index],
              type: "activity",
              period: this.activePeriod,
              aggregationType: this.getAggregationType(name),
            });
            if (this._renderId !== renderId) {
              this.disposeChart(chart);
              return;
            }
            this.charts[index] = chart;
          },
        });
      });

      const growthElement = this.getRefElement("activitygrowth");
      if (growthElement) {
        const growthIndex = this.canShowChart.length;
        jobs.push({
          el: growthElement,
          run: async () => {
            let processedGrowth = PageCharts.growth({ pages });
            if (this.activePeriod !== "daily") {
              processedGrowth = this.aggregateChartData(processedGrowth, this.activePeriod, "growth");
            }
            processedGrowth = processedGrowth.map((item) => {
              const newItem = { ...item };
              for (let i = 0; i < pages.length; i++) {
                if (typeof newItem[`growth_${i}`] === "undefined") newItem[`growth_${i}`] = null;
              }
              if (typeof item.date === "number") return newItem;
              if (item.date instanceof Date) return { ...newItem, date: item.date.getTime() };
              return { ...newItem, date: new Date(item.date).getTime() };
            });
            const chart = await Columns({
              pages,
              ref: [growthElement],
              chartData: processedGrowth,
              field: "growth",
              category: "date",
              colors: this.$colors,
              period: this.activePeriod,
            });
            if (this._renderId !== renderId) {
              this.disposeChart(chart);
              return;
            }
            this.charts[growthIndex] = chart;
          },
        });
      }

      this.getAnalizedAdminPages.forEach((page, idx) => {
        const chartElement = this.getRefElement(`activitysubunsub${idx}`);
        if (!chartElement) return;
        const chartIndex = this.canShowChart.length + 1 + idx;
        jobs.push({
          el: chartElement,
          run: async () => {
            let processedSubUnsub = PageCharts.SubUnsub({ page });
            if (this.activePeriod !== "daily") {
              processedSubUnsub = this.aggregateChartData(processedSubUnsub, this.activePeriod, "subunsub");
            }
            const chart = await ColumnsOne({
              page,
              ref: [chartElement],
              chartData: processedSubUnsub,
              fields: [
                { field: "subscribed", stacked: false },
                { field: "unsubscribed", stacked: true },
              ],
              category: "date",
              color: page.colorName,
              period: this.activePeriod,
            });
            if (this._renderId !== renderId) {
              this.disposeChart(chart);
              return;
            }
            this.charts[chartIndex] = chart;
          },
        });
      });

      this._stopCharts = scheduleCharts(jobs, { batchSize: 3 });
    },
    
    // Helper to aggregate data for different periods
    aggregateChartData(data, period, chartType) {
      if (period === 'daily' || !data) return data;
      
      // Clone the data to avoid mutations
      const result = JSON.parse(JSON.stringify(data));
      
      if (chartType === 'growth') {
        // For growth chart, we need to group by week or month
        if (!Array.isArray(result)) return result;
        
        const aggregated = [];
        const groupedData = {};
        
        // Group data by period
        result.forEach(item => {
          const date = moment(item.date);
          let key;
          
          if (period === 'weekly') {
            // Get first day of the week as key
            const weekStart = date.clone().startOf('week');
            key = weekStart.valueOf();
          } else if (period === 'monthly') {
            // Get first day of the month as key
            const monthStart = date.clone().startOf('month');
            key = monthStart.valueOf();
          }
          
          if (!groupedData[key]) {
            // Initialize a new group with the correct structure
            const newGroup = {
              date: key
            };
            
            // Copy all properties that match growth_X pattern
            Object.keys(item).forEach(prop => {
              if (prop.startsWith('growth_')) {
                newGroup[prop] = 0;
              }
            });
            
            groupedData[key] = newGroup;
          }
          
          // Sum up growth values for each page
          Object.keys(item).forEach(prop => {
            if (prop.startsWith('growth_')) {
              groupedData[key][prop] += (item[prop] || 0);
            }
          });
        });
        
        // Convert grouped data back to array
        return Object.values(groupedData).sort((a, b) => a.date - b.date);
      }
      else if (chartType === 'subunsub') {
        // For sub/unsub data
        if (!Array.isArray(result)) return result;
        
        const aggregated = [];
        const groupedData = {};
        
        // Group data by period
        result.forEach(item => {
          const date = moment(item.date);
          let key;
          
          if (period === 'weekly') {
            // Get first day of the week as key
            const weekStart = date.clone().startOf('week');
            key = weekStart.valueOf();
          } else if (period === 'monthly') {
            // Get first day of the month as key
            const monthStart = date.clone().startOf('month');
            key = monthStart.valueOf();
          }
          
          if (!groupedData[key]) {
            groupedData[key] = {
              date: key,
              subscribed: 0,
              unsubscribed: 0,
              count: 0
            };
          }
          
          // Sum up subscribed and unsubscribed values
          groupedData[key].subscribed += (item.subscribed || 0);
          groupedData[key].unsubscribed += (item.unsubscribed || 0);
          groupedData[key].count++;
        });
        
        // Convert grouped data back to array
        Object.values(groupedData).forEach(group => {
          aggregated.push({
            date: group.date,
            subscribed: group.subscribed,
            unsubscribed: group.unsubscribed
          });
        });
        
        return aggregated;
      }
      
      // Default case, return original data
      return result;
    },
    
    togglePeriod(id) {
      this.openPeriod = this.openPeriod === id ? null : id;
    },
    closePeriod(id) {
      if (this.openPeriod === id) this.openPeriod = null;
    },
    setPeriod(period) {
      this.openPeriod = null;
      if (this.activePeriod !== period) {
        this.activePeriod = period;
        
        // Use Vue's nextTick to ensure DOM is updated before recreating charts
        this.$nextTick(() => {
          this.renderCharts();
        });
      }
    },
    
    // Export a line chart (activity charts)
    async exportLineChart(name, type) {
      const chartIndex = this.charts.findIndex(
        (chart, index) => this.canShowChart[index] === name
      );
      
      if (chartIndex === -1 || !this.charts[chartIndex]) {
        return;
      }
      
      const chart = this.charts[chartIndex];
      const refKey = `activity${name}`;
      const chartElement = this.getRefElement(refKey);
      
      if (!chartElement) {
        return;
      }
      
      const colors = Object.entries(this.$colors).map(([key, value], idx) => {
        return { key, value };
      });
      
      // Save current period for recreation
      const currentPeriod = this.activePeriod;
      
      await exportLinesChart({
        chart,
        container: chartElement,
        chartData: this.getUnionPagesData,
        name,
        type: "activity",
        color: colors[this.canShowChart.indexOf(name)],
        period: this.activePeriod,
        exportType: type
      });
      
      // Immediately recreate all charts without delay
      this.renderCharts();
    },
    
    // Export the growth chart
    async exportGrowthChart(type) {
      // Find the growth chart in the charts array
      const growthChartIndex = this.canShowChart.length; // Growth chart is after activity charts
      const chart = this.charts[growthChartIndex];
      
      if (!chart) {
        return;
      }
      
      const chartElement = this.getRefElement('activitygrowth');
      if (!chartElement) {
        return;
      }
      
      // Calculate growth data
      const dataGrowth = PageCharts.growth({ pages: this.getUnionPagesData.pages });
      let processedGrowth = dataGrowth;
      
      if (this.activePeriod !== 'daily') {
        processedGrowth = this.aggregateChartData(dataGrowth, this.activePeriod, 'growth');
      }
      
      // Process data for proper date format
      processedGrowth = processedGrowth.map(item => {
        if (typeof item.date === 'number') {
          return item;
        } else if (item.date instanceof Date) {
          return { ...item, date: item.date.getTime() };
        } else {
          return { ...item, date: new Date(item.date).getTime() };
        }
      });
      
      await exportColumnsChart({
        chart,
        container: chartElement,
        chartData: processedGrowth,
        pages: this.getUnionPagesData.pages,
        field: "growth",
        period: this.activePeriod,
        colors: this.$colors,
        type
      });
      
      // Immediately recreate charts
      this.renderCharts();
    },
    
    // Export a sub/unsub chart
    async exportSubUnsubChart(index, type) {
      // Offset to account for activity charts and growth chart
      const chartIndex = this.canShowChart.length + 1 + index;
      const chart = this.charts[chartIndex];
      
      if (!chart) {
        return;
      }
      
      const page = this.getAnalizedAdminPages[index];
      const refKey = `activitysubunsub${index}`;
      const chartElement = this.getRefElement(refKey);
      
      if (!chartElement) {
        return;
      }
      
      // Get sub/unsub data
      const subUnsub = PageCharts.SubUnsub({ page });
      let processedSubUnsub = subUnsub;
      
      if (this.activePeriod !== 'daily') {
        processedSubUnsub = this.aggregateChartData(subUnsub, this.activePeriod, 'subunsub');
      }
      
      await exportColumnsOneChart({
        chart,
        container: chartElement,
        chartData: processedSubUnsub,
        page,
        fields: [
          { field: "subscribed", stacked: false },
          { field: "unsubscribed", stacked: true },
        ],
        period: this.activePeriod,
        color: page.colorName,
        type
      });
      
      // Immediately recreate charts
      this.renderCharts();
    },
  },
  
  created() {
    this.charts = [];
  },
  mounted() {
    // Use nextTick to ensure DOM is ready before rendering charts
    this.$nextTick(() => {
      setTimeout(() => {
        this.renderCharts();
      }, 100); // Small delay to ensure DOM elements are fully rendered
    });
  },

  beforeDestroy() {
    if (this._stopCharts) this._stopCharts();
    this.charts.forEach((chart) => this.disposeChart(chart));
  },
};
</script>
